<template>
  <div>
    <Header></Header>
    <v-container fluid grid-list-xl>
      <v-layout row>
        <v-flex xs12 xl12 md12 sm12 lg12 class="mt-4">
          <div class="title text-xs-center form-divider margin-top-40px">ثبت اخبار</div>
        </v-flex>
      </v-layout>
      <v-form v-model="valid" lazy-validation>
        <v-layout row>
          <!-- <v-flex xs12 sm6 md6 xl4 lg4> -->
            <!-- <v-text-field
              v-model="USERNAME"
              :rules="nameRules"
              solo
              placeholder="عنوان مطلب"
              hint="فقط حروف فارسی پشتیبانی میشود"
              append-icon="account_circle"
              clearable
              required
            ></v-text-field> -->
            <!-- <v-text-field></v-text-field> -->
          <!-- </v-flex> -->
          <v-flex xs12 sm6 md6 xl4 lg4>
            <!-- <v-text-field v-show='false' type="file" ref="file" v-model="DRVIMAGE"
                                    style="display: none" solo placeholder="عکس" prepend-inner-icon="add_a_photo"
                                    class="ltr">
            </v-text-field>-->
            <input type="file" ref="file" @change="onFileChanged" style="display: none" />
            <v-btn @click="$refs.file.click()" class="white bt">
              <v-icon>add_a_photo</v-icon>
            </v-btn>
          </v-flex>

          <v-flex xs12 sm6 md6 xl4 lg4 style="margin-top:8px;">
            <date-picker></date-picker>
          </v-flex>
          <v-flex xs12 sm6 md6 xl4 lg4>
            <v-btn
              block
              color="indigo"
              dark
              :loading="userRegisterLoading"
              @click="RegisterUser"
              class="bt"
            >
              <v-icon>done</v-icon>ثبت
            </v-btn>
          </v-flex>
        </v-layout>name
      </v-form>
      <v-flex xs12 sm12 md12 xl12 lg12>
        <v-textarea
          id="editor1"
          rows="10"
          cols="80"
          solo
          name="contents"
          label="Solo textarea"
          value="سلام حال شما چطوره"
        ></v-textarea>
      </v-flex>
    </v-container>
  </div>
</template>

<script>
import Header from "@/components/dashboard/Header";

export default {
  data() {
    return {
      entity: {
        title: null,
        image: null,
        date: null,
        content: null
      }
    };
  },
  components: {
    Header
  }
};
</script>

<style scoped>
.margin-top-40px {
  margin-top: 50px;
}
.bt {
  height: 48px;
  margin: 0;
  width: 100%;
}
</style>
